<template>
  <sui-page>
    <sui-page-header :pageId="this.$options.name" />
    <sui-page-contents>
      <div>
        <div class="comm_scr_wrap">
          <div class="row">
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CSCT_CD')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchBox.costCenterId"
                maxlength="50"
                @keyup.enter="onSearchClick"
              />
            </div>
            <div class="col-xs-1">
              <sui-input-label
                :label="$t('MSG_TXT_CSCT_NM')"
                :vertical="false"
              />
            </div>
            <div class="col-xs-3">
              <sui-text-field
                v-model.trim="searchBox.costCenterName"
                maxlength="50"
                @keyup.enter="onSearchClick"
              />
            </div>
            <div class="btn_wrap">
              <sui-button
                type="button"
                class="comm_btn_Reset"
                @click="onResetClick"
              >
                {{ $t("MSG_BTN_RESET") }}
              </sui-button>
              <sui-button
                type="button"
                class="comm_btn_Scr"
                @click="onSearchClick"
              >
                {{ $t("MSG_BTN_SEARCH") }}
              </sui-button>
            </div>
          </div>
        </div>
        <div class="mrB30" />
        <sui-grid
          :columns="gridColumns0"
          :dataset="'dsCostCenter'"
          :initialPagesize="5"
          :showDisplayCountControl="false"
        />
        <div class="btn_moreView">
          <p
            :class="pageing.totalCount === 0 || pageing.count === pageing.totalCount ? 'disabled' : ''"
            @click="onAddList"
          >
            {{ $t("MSG_TXT_SHOW_MORE") }} {{ showMoreCount }}
          </p>
        </div>
      </div>
    </sui-page-contents>
    <sui-page-footer>
      <div class="comm_btn_wrap">
        <sui-button
          type="button"
          class="comm_btn_border"
          @click="onCancelClick"
        >
          {{ $t('MSG_BTN_CLOSE') }}
        </sui-button>
        <sui-button
          type="button"
          class="comm_btn_solid"
          @click="onSelectClick"
        >
          {{ $t('MSG_BTN_APPLY') }}
        </sui-button>
      </div>
    </sui-page-footer>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';

export default {
  name: 'PGE_CMY_00025', // eslint-disable-line vue/name-property-casing
  extends: BasePage,
  props: {
    closePagePopup: {
      type: Function,
      default: () => {},
    },
    pageInitialData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isPageing: false,
      pageing: {
        pagePerCount: 5000,
        currentPage: 1,
        totalCount: 0,
        count: 0,
      },

      // 더보기 SearchBox
      showMoreSearchBox: {},

      searchBox: {
        costCenterId: '',
        costCenterName: '',
      },

      localdata0: [],
      gridColumns0: [{
        text: this.$t('MSG_TXT_CSCT_CD'),
        datafield: 'costCenterId',
      }, {
        text: this.$t('MSG_TXT_CSCT_NM'),
        datafield: 'costCenterName',
      }, {
        text: this.$t('MSG_TXT_JOB_CATG'),
        datafield: 'costCenterTaskNumber',
      }],
    };
  },
  computed: {
    // 계산된 속성, date pickproperty로 사용가능
    showMoreCount() {
      return `(${this.pageing.count}/${this.pageing.totalCount})`;
    },
  },
  watch: {
    // data 변경시 특정 함수를 호출 해야 하는 경우(async 등)
  },
  datasets: [{
    id: 'dsCostCenter',
    type: 'local',
    data: 'localdata0',
    datafields: [{
      name: 'costCenterId',
      type: 'string',
      map: 'costCenterId',
    }, {
      name: 'costCenterValidityStartDT',
      type: 'string',
      map: 'costCenterValidityStartDT',
    }, {
      name: 'costCenterValidityFinishDT',
      type: 'string',
      map: 'costCenterValidityFinishDT',
    }, {
      name: 'companyCode',
      type: 'string',
      map: 'companyCode',
    }, {
      name: 'costCenterName',
      type: 'string',
      map: 'costCenterName',
    }, {
      name: 'costCenterContent',
      type: 'string',
      map: 'costCenterContent',
    }, {
      name: 'controllingAreaNumber',
      type: 'string',
      map: 'controllingAreaNumber',
    }, {
      name: 'costCenterTaskNumber',
      type: 'string',
      map: 'costCenterTaskNumber',
    }, {
      name: 'businessAreaNumber',
      type: 'string',
      map: 'businessAreaNumber',
    }, {
      name: 'costCenterPICNumber',
      type: 'string',
      map: 'costCenterPICNumber',
    }, {
      name: 'costCenterCategoryNumber',
      type: 'string',
      map: 'costCenterCategoryNumber',
    }, {
      name: 'profitCenterNumber',
      type: 'string',
      map: 'profitCenterNumber',
    }, {
      name: 'costCenterTaskCategoryNumber',
      type: 'string',
      map: 'costCenterTaskCategoryNumber',
    }],
  }],
  mounted() {
    const has = Object.prototype.hasOwnProperty;

    if (this.pageInitialData !== null) {
      if (has.call(this.pageInitialData, 'costCenterId')
          && this.pageInitialData.costCenterId !== null
          && utils.isEmpty(this.pageInitialData.costCenterId) === false) {
        this.searchBox.costCenterId = this.pageInitialData.costCenterId;
      }

      if (has.call(this.pageInitialData, 'costCenterName')
          && this.pageInitialData.costCenterName !== null
          && utils.isEmpty(this.pageInitialData.costCenterName) === false) {
        this.searchBox.costCenterName = this.pageInitialData.costCenterName;
      }
    }
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    /** ***************************************************************************
        이벤트 영역
        ***************************************************************************** */
    onResetClick() {
      this.resetSearchBox();
    },
    onSearchClick() {
      this.pageing.currentPage = 1;
      this.pageing.totalCount = 0;
      this.pageing.count = 0;

      this.dsCostCenter.setRawData([]);

      this.setShowMoreSearchBox();
      this.searchCostCenter();

      return true;
    },
    onAddList() {
      if (this.isPageing) {
        this.pageing.currentPage += 1;
        this.searchCostCenter();
      }
    },
    onSelectClick() {
      const selectedRawsData = this.dsCostCenter.getSelectedRawData();
      if (selectedRawsData.length <= 0) {
        utils.messageBox('warning', this.$t('MSG_ALT_NOT_SEL_ITEM'));
        return false;
      }
      this.closePagePopup(selectedRawsData);
      return true;
    },
    onCancelClick() {
      this.closePagePopup();
    },
    /** ***************************************************************************
        함수 영역 : 사용자 정의 함수
        ***************************************************************************** */
    setShowMoreSearchBox() {
      // searchBox -> paramsObj변환 { key : value, key : value }
      const queryParams = utils.reduce(this.searchBox, (result, value, key) => {
        const objResult = utils.clone(result);
        if (utils.isUndefined(value) === false && value !== null) {
          objResult[key] = utils.isUndefined(value.key) ? utils.trim(value) : utils.trim(value.key);
        }
        return objResult;
      }, {});

      this.showMoreSearchBox = queryParams;
    },
    resetSearchBox() {
      const has = Object.prototype.hasOwnProperty;
      utils.forEach(this.searchBox, (values, key) => {
        if (has.call(this.searchBox[key], 'key')) {
          this.searchBox[key] = { key: '', label: '' };
        } else {
          this.searchBox[key] = '';
        }
      });
    },
    searchCostCenter() {
      const queryParams = utils.cloneDeep(this.showMoreSearchBox);

      // pageing
      utils.assign(queryParams, { pagePerCount: this.pageing.pagePerCount });
      utils.assign(queryParams, { currentPage: this.pageing.currentPage });

      http.request(this.$options.name, 'DTS_CMY_00057', {
        query: queryParams,
      }).then(res => {
        if (utils.isUndefined(res.data) === false && res.data.length === this.pageing.pagePerCount) {
          this.isPageing = true;
        } else {
          this.isPageing = false;
        }


        const union = utils.mergeArray(this.dsCostCenter.data, res.data);
        this.dsCostCenter.setRawData(union);

        this.pageing.count = this.dsCostCenter.data.length;
        if (res.data.length > 0) {
          this.pageing.totalCount = res.data[0].totalCount;
        }

        console.log(res);
      }).catch(error => {
        console.log(error);
      });
    },
  },
};
</script>
<style scoped>
</style>
